exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-button {\r\n  width: 100%;\r\n  text-decoration: none;\r\n  text-align:left;\r\n  color: #3eb049;\r\n}\r\n\r\nul {\r\n  list-style-type:none;\r\n  padding:0;\r\n  margin: 0;\r\n  position: relative;\r\n  top: 15px;\r\n}\r\n\r\nli {\r\n  line-height:20px;\r\n  border-bottom:1px solid #ccc;\r\n}\r\n\r\n.uw-button {\r\n    line-height: 15px;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/sidebar/sidebar.component.css
// module id = ../../../../../src/app/sidebar/sidebar.component.css
// module chunks = main